export const userCenter = {
    inspirationList: 'AI灵感',
    bind: '进行绑定',
    unbind: ' 您还未绑定微信，无法多端同步管理项目，',
    bindSuccess: '绑定成功',
    countDown: '弹窗 {seconds} 秒自动关闭',
    refreshQRCode: '点击刷新二维码',
};
